
angular.module('bmsApp.employeeHoliday').controller('EmployeeHolidayIndexCtrl', []);
